
import { createContext } from 'react';

const preguntasContext = createContext();

export default preguntasContext;